import { Creator } from "#api/creators";

export interface IPaySite {
  title: string;
  color: string;
  user: {
    profile: (creator: Creator) => string;
    profileFromId: (id: string) => string;
  };
  post: {};
}

export const paysites: Record<string, IPaySite> = {
  patreon: {
    title: "Patreon",
    color: "#fa5742",
    user: {
      profile: (creator) => {
        if (creator.public_id) {
          return `https://www.patreon.com/${creator.public_id}`;
        }
        return `https://www.patreon.com/user?u=${creator.id}`;
      },
      profileFromId: (id) => `https://www.patreon.com/user?u=${id}`
    },
    post: {},
  },
  fanbox: {
    title: "Pixiv Fanbox",
    color: "#2c333c",
    user: {
      profile: (creator) => `https://www.pixiv.net/fanbox/creator/${creator.id}`,
      profileFromId: (id) => `https://www.pixiv.net/fanbox/creator/${id}`,
    },
    post: {},
  },
  subscribestar: {
    title: "SubscribeStar",
    color: "#009688",
    user: {
      profile: (creator) => `https://subscribestar.adult/${creator.id}`,
      profileFromId: (id) => `https://subscribestar.adult/${id}`,
    },
    post: {},
  },
  gumroad: {
    title: "Gumroad",
    color: "#2b9fa4",
    user: {
      profile: (creator) => {
        if (creator.public_id) {
          return `https://${creator.public_id}.gumroad.com/`;
        }
        return `https://gumroad.com/${creator.id}`;
      },
      profileFromId: (id) => `https://gumroad.com/${id}`,
    },
    post: {},
  },
  discord: {
    title: "Discord",
    color: "#5165f6",
    user: {
      profile: (creator) => ``,
      profileFromId: (id) => ``,
    },
    post: {},
  },
  dlsite: {
    title: "DLsite",
    color: "#052a83",
    user: {
      profile: (creator) => `https://www.dlsite.com/eng/circle/profile/=/maker_id/${creator.id}`,
      profileFromId: (id) => `https://www.dlsite.com/eng/circle/profile/=/maker_id/${id}`,
    },
    post: {},
  },
  fantia: {
    title: "Fantia",
    color: "#e1097f",
    user: {
      profile: (creator) => `https://fantia.jp/fanclubs/${creator.id}`,
      profileFromId: (id) => `https://fantia.jp/fanclubs/${id}`,
    },
    post: {},
  },
  boosty: {
    title: "Boosty",
    color: "#fd6035",
    user: {
      profile: (creator) => `https://boosty.to/${creator.id}`,
      profileFromId: (id) => `https://boosty.to/${id}`,
    },
    post: {},
  },
  afdian: {
    title: "Afdian",
    color: "#9169df",
    user: {
      profile: (creator) => ``,
      profileFromId: (id) => ``,
    },
    post: {},
  },
  fansly: {
    title: "Fansly",
    color: "#2399f7",
    user: {
      profile: (creator) => `https://fansly.com/${creator.id}`,
      profileFromId: (id) => `https://fansly.com/${id}`,
    },
    post: {},
  },
  onlyfans: {
    title: "OnlyFans",
    color: "#008ccf",
    user: {
      profile: (creator) => `https://onlyfans.com/${creator.id}`,
      profileFromId: (id) => `https://onlyfans.com/${id}`,
    },
    post: {},
  },
  candfans: {
    title: "CandFans",
    color: "#e8486c",
    user: {
      profile: (creator) => `https://candfans.jp/${creator.id}`,
      profileFromId: (id) => `https://candfans.jp/${id}`,
    },
    post: {},
  },
};
